import { render, staticRenderFns } from "./ChapterTraining.vue?vue&type=template&id=3de6fc59"
import script from "./ChapterTraining.vue?vue&type=script&lang=js"
export * from "./ChapterTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports